'use strict';

import React, { Component } from 'react';
import { Typography, Box } from '@material-ui/core';

/**
 * AudioPlayerSAV — lecteur audio + dialogue diarizé horodaté.
 *
 * Props :
 *   audio {Object} :
 *     audioId      {string}            Identifiant de l'audio (URL = /audio/<audioId>)
 *     transcript   {string}            Transcription intégrale (mono-locuteur)
 *     summary      {string|null}       Résumé IA (présent si speakerCount >= 2)
 *     segments     {Array}             Liste des segments diarizés (≤ 40, bornés côté serveur)
 *       segment : { speaker, start, end, text }
 *       speaker : "Locuteur 1", "Locuteur 2", … (dérivé de speaker_id par domainModel)
 *       start/end : secondes (float)
 *     speakerCount {number}            Nombre de locuteurs détectés
 *
 * Affichage :
 *   - Lecteur audio natif (<audio controls>)
 *   - Pas de résumé ici : il est déjà dans la description de la panne (évite le doublon)
 *   - Si segments : dialogue horodaté, regroupement visuel par locuteur (couleur de bordure)
 *     Format : Locuteur N [mm:ss–mm:ss] : texte
 *   - Si segments.length >= 40 : mention "dialogue tronqué (40 premiers tours)"
 *   - Si pas de segments et pas de summary : affiche transcript brut
 */

var SPEAKER_COLORS = [
    '#1565C0',  // Locuteur 1 — bleu
    '#2E7D32',  // Locuteur 2 — vert
    '#6A1B9A',  // Locuteur 3 — violet
    '#E65100',  // Locuteur 4 — orange
    '#00695C',  // Locuteur 5 — teal
];

function formatTime(seconds) {
    var m = Math.floor(seconds / 60);
    var s = Math.floor(seconds % 60);
    return (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
}

function speakerColor(speaker) {
    if (!speaker) return '#555';
    var match = speaker.match(/(\d+)\s*$/);
    var idx = match ? (parseInt(match[1], 10) - 1) : 0;
    return SPEAKER_COLORS[idx % SPEAKER_COLORS.length] || '#555';
}

class AudioPlayerSAV extends Component {
    render() {
        var audio = this.props.audio;
        if (!audio || !audio.audioId) return null;

        var audioId = audio.audioId;
        var transcript = audio.transcript;
        var segments = audio.segments;
        var isTruncated = segments && segments.length >= 40;
        var hasSegments = segments && segments.length > 0;

        return (
            <div style={{ marginTop: 8 }}>
                <audio
                    controls
                    src={'/audio/' + audioId}
                    style={{ width: '100%', marginBottom: 8 }}
                >
                    Votre navigateur ne supporte pas la lecture audio.
                </audio>

                {hasSegments ? (
                    <Box>
                        <Typography
                            variant="subtitle2"
                            style={{ marginBottom: 6, color: '#555', fontWeight: 600 }}
                        >
                            Dialogue ({isTruncated ? '40 premiers tours' : segments.length + ' tour(s)'})
                        </Typography>
                        {segments.map(function(seg, idx) {
                            var color = speakerColor(seg.speaker);
                            return (
                                <Box
                                    key={idx}
                                    style={{
                                        marginBottom: 6,
                                        paddingLeft: 10,
                                        borderLeft: '3px solid ' + color
                                    }}
                                >
                                    <Typography
                                        variant="caption"
                                        style={{
                                            color: color,
                                            fontWeight: 600,
                                            display: 'block',
                                            lineHeight: 1.4
                                        }}
                                    >
                                        {seg.speaker} [{formatTime(seg.start)}–{formatTime(seg.end)}]
                                    </Typography>
                                    <Typography variant="body2" style={{ color: '#222' }}>
                                        {seg.text}
                                    </Typography>
                                </Box>
                            );
                        })}
                        {isTruncated ? (
                            <Typography
                                variant="caption"
                                style={{ color: '#888', marginTop: 4, display: 'block', fontStyle: 'italic' }}
                            >
                                dialogue tronqué (40 premiers tours)
                            </Typography>
                        ) : null}
                    </Box>
                ) : transcript ? (
                    <Typography variant="body2" style={{ marginTop: 4, color: '#333' }}>
                        {transcript}
                    </Typography>
                ) : null}
            </div>
        );
    }
}

export default AudioPlayerSAV;
